module.exports = __webpack_public_path__ + "img/m2.ec0e5a66.png";